import { context, propagation } from '@opentelemetry/api'
import {
  MethodInfo,
  NextServerStreamingFn,
  NextUnaryFn,
  RpcInterceptor,
  RpcOptions,
  ServerStreamingCall,
  UnaryCall,
} from '@protobuf-ts/runtime-rpc'

const RPC_METADATA_SETTER = {
  set(carrier: Record<string, string>, key: string, value: string) {
    carrier[key] = value
  },
}

/** Injects active OTel context (W3C + Datadog) into gRPC metadata for downstream services. */
export function injectTraceContextIntoRpcMeta(options: RpcOptions): void {
  const carrier: Record<string, string> = {}
  propagation.inject(context.active(), carrier, RPC_METADATA_SETTER)

  if (Object.keys(carrier).length === 0) {
    return
  }

  if (!options.meta) {
    options.meta = {}
  }

  for (const [key, value] of Object.entries(carrier)) {
    options.meta[key] = value
  }
}

/**
 * Propagates the active OpenTelemetry context into protobuf-ts gRPC metadata.
 * Required because most K2 traffic uses gRPC/gRPC-Web, not instrumented fetch alone.
 */
export class TracePropagationInterceptor implements RpcInterceptor {
  interceptUnary(
    next: NextUnaryFn,
    method: MethodInfo,
    input: object,
    options: RpcOptions,
  ): UnaryCall {
    injectTraceContextIntoRpcMeta(options)
    return next(method, input, options)
  }

  interceptServerStreaming(
    next: NextServerStreamingFn,
    method: MethodInfo,
    input: object,
    options: RpcOptions,
  ): ServerStreamingCall {
    injectTraceContextIntoRpcMeta(options)
    return next(method, input, options)
  }
}
